import { Component, HostListener, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TekinputService } from '../../service/tekinput.service';

@Component({
  selector: 'radio-buttons',
  templateUrl: './radio-buttons.component.html',
  styleUrls: ['./radio-buttons.component.scss'],
})
export class RadioButtonsComponent implements OnInit, OnChanges {
  @Input() labelText = '';
  @Input() controlName = '';
  @Input() id = '';
  @Input() isCorrect = false;
  @Input() teacherSolution = false;
  @Input() disabled = false;
  @Input() validated = false;
  @Input() checked = false;
  @Input() isTeacher = false;
  @Input() value: string;
  safeHtml: SafeHtml;

  constructor(private readonly sanitizer: DomSanitizer, private readonly tekInputService: TekinputService) {}

  ngOnInit() {
    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.labelText);
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['labelText']?.currentValue !== undefined) {
      this.safeHtml = this.sanitizer.bypassSecurityTrustHtml((this.labelText = changes['labelText'].currentValue));
    }
  }

  @HostListener('click', ['$event'])
  onKeyDown(event: any) {
    this.tekInputService.setIsEditingInput(true);
  }
}
